import { useIsAllowedPermission } from '@mint-lib/profile-helpers';

export const useReadOnly = (): boolean => {
  return !useIsAllowedPermission('integrations:modify');
};
